module.exports = __webpack_public_path__ + "assets/img/01.110efee2.png";